import React /*, { useEffect, useRef, useState }*/ from "react";
import { Typography } from "antd";
// import jwtDecode from "jwt-decode";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
// import { useLocation } from "react-router-dom";
// import { fetchConnectedSources } from "../apiHandlerGlobal";
import { useTranslation } from "react-i18next";
import { useLanguage } from "src/hooks/useLanguage";
import { CONNECTED_SOURCES } from "./connectedSourcesConfig";

const { Title, Paragraph } = Typography;

// Disabled for Saudi demo — token/localStorage auth and live source-status APIs
// are not needed in this environment. Re-enable when reconnecting real API auth.
// interface DecodedToken {
//   user_id: string;
//   tenant_id: string;
//   role_id: string;
//   api_key: string;
//   company_name: string;
//   environment?: string;
//   environment_id?: string;
//   env?: string;
//   env_id?: string;
// }

// interface SourceApiResponse {
//   status: boolean;
//   source_ids: number[];
// }

// type SourceCard = {
//   name: string;
//   icon: string;
//   className: string;
// };

// const BASE_SOURCES: SourceCard[] = [
//   { name: "Shopify", icon: "/Icons/Shopify.svg", className: "shopify" },
//   { name: "Facebook", icon: "/Icons/FB.svg", className: "facebook" },
//   { name: "GoogleAds", icon: "/Icons/Ads.svg", className: "google-ads" },
//   {
//     name: "GoogleAnalytics4",
//     icon: "/Icons/GA.svg",
//     className: "google-analytics",
//   },
//   { name: "Instagram", icon: "/Icons/Instalogo.png", className: "instagram" },
// ];

// const ODOO_SOURCE: SourceCard = {
//   name: "Odoo",
//   icon: "/images/odoo.svg",
//   className: "odoo",
// };

// const SOURCE_ID_TO_NAME_MAP: Record<number, string> = {
//   1: "Shopify",
//   2: "Facebook",
//   //3: "Instagram",
//   4: "GoogleAds",
//   5: "GoogleAnalytics4",
//   6: "Odoo",
// };

// const normalizeEnvironment = (value?: string | null): string =>
//   (value ?? "").trim().toLowerCase();

// const getEnvironmentFromApiBaseUrl = (): string => {
//   const apiBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim();

//   if (!apiBaseUrl) {
//     return "";
//   }

//   const normalizedUrl = normalizeEnvironment(apiBaseUrl);
//   if (normalizedUrl.includes("demo")) {
//     return "demo";
//   }
//   if (normalizedUrl.includes("dev")) {
//     return "dev";
//   }

//   return "";
// };

// const getEnvironmentId = (
//   token: string | null,
//   params: URLSearchParams
// ): string => {
//   const apiBaseEnvironment = getEnvironmentFromApiBaseUrl();
//   if (apiBaseEnvironment) {
//     return apiBaseEnvironment;
//   }

//   const queryEnvironment =
//     params.get("environment_id") ??
//     params.get("environmentId") ??
//     params.get("environment") ??
//     params.get("env_id") ??
//     params.get("env");

//   if (queryEnvironment) {
//     return normalizeEnvironment(queryEnvironment);
//   }

//   if (token) {
//     try {
//       const decodedToken = jwtDecode<DecodedToken>(token);
//       const tokenEnvironment =
//         decodedToken.environment_id ??
//         decodedToken.environment ??
//         decodedToken.env_id ??
//         decodedToken.env;

//       if (tokenEnvironment) {
//         return normalizeEnvironment(tokenEnvironment);
//       }
//     } catch {
//       // Ignore token parse failure here. The existing effect handles logging.
//     }
//   }

//   const storedEnvironment =
//     localStorage.getItem("environment_id") ??
//     localStorage.getItem("environmentId") ??
//     localStorage.getItem("environment") ??
//     localStorage.getItem("env_id") ??
//     localStorage.getItem("env");

//   if (storedEnvironment) {
//     return normalizeEnvironment(storedEnvironment);
//   }

//   const hostname = window.location.hostname.toLowerCase();
//   if (hostname.includes("demo")) {
//     return "demo";
//   }
//   if (hostname.includes("dev")) {
//     return "dev";
//   }

//   return "";
// };

const ConnectedSources: React.FC = () => {
  // const [connectedSources, setConnectedSources] = useState<string[]>([]);
  // const [clickedSources, setClickedSources] = useState<string[]>([]);
  // const [, setIsLoading] = useState(true);
  // const hasFetchedRef = useRef(false);
  const { t } = useTranslation();
  const { direction } = useLanguage();

  // const location = useLocation();
  // const params = new URLSearchParams(location.search);
  // const token = params.get("token");
  // const environmentId = getEnvironmentId(token, params);
  // const sources =
  //   environmentId === "demo" ? [...BASE_SOURCES, ODOO_SOURCE] : BASE_SOURCES;

  // Store token on first load
  // useEffect(() => {
  //   if (token) {
  //     try {
  //       const decoded = jwtDecode<DecodedToken>(token);
  //       localStorage.setItem("user_id", decoded.user_id);
  //       localStorage.setItem("tenant_id", decoded.tenant_id);
  //       localStorage.setItem("role_id", decoded.role_id);
  //       localStorage.setItem("api_key", decoded.api_key);
  //       localStorage.setItem("company_name", decoded.company_name);
  //       localStorage.setItem("auth_token", token);
  //       const resolvedEnvironment =
  //         decoded.environment_id ??
  //         decoded.environment ??
  //         decoded.env_id ??
  //         decoded.env;
  //       if (resolvedEnvironment) {
  //         localStorage.setItem("environment_id", resolvedEnvironment);
  //       }
  //
  //       const newUrl = `${window.location.origin}${window.location.pathname}`;
  //       window.history.replaceState({}, document.title, newUrl);
  //     } catch (error) {
  //       console.error("Failed to decode token:", error);
  //     }
  //   }
  // }, [token]);

  // Fetch backend connected sources
  // useEffect(() => {
  //   if (hasFetchedRef.current) {
  //     return;
  //   }
  //   hasFetchedRef.current = true;
  //
  //   const fetchSources = async () => {
  //     const tenantId = localStorage.getItem("tenant_id");
  //     const apiKey = localStorage.getItem("api_key");
  //
  //     if (!tenantId || !apiKey) {
  //       console.warn("Missing credentials for source fetch");
  //       return;
  //     }
  //
  //     try {
  //       const data = (await fetchConnectedSources(
  //         tenantId,
  //         apiKey
  //       )) as SourceApiResponse;
  //
  //       if (data && data.status) {
  //         const connected = data.source_ids
  //           .map((id: number) => SOURCE_ID_TO_NAME_MAP[id])
  //           .filter((name): name is string => Boolean(name));
  //         setConnectedSources(connected);
  //       }
  //     } catch (error) {
  //       console.error("Failed to fetch sources", error);
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   };
  //
  //   fetchSources();
  // }, []);

  // const handleCardClick = (source: string) => {
  //   if (!connectedSources.includes(source)) {
  //     setClickedSources(prev => [...prev, source]);
  //   }
  // };
  //
  // const isClicked = (name: string) => clickedSources.includes(name);
  // const isConnected = (name: string) => connectedSources.includes(name);
  //
  // {sources.map(({ name, icon, className }) => {
  //   const connected = isConnected(name);
  //   const clicked = isClicked(name);
  //   const cardClass = `connected-card ${className} ${
  //     connected ? "highlight-border" : ""
  //   }`;
  //
  //   return (
  //     <Tippy
  //       content={
  //         connected
  //           ? t("sourceConnectorNew.connected")
  //           : t("sourceConnectorNew.disconnected")
  //       }
  //     >
  //       <div
  //         key={name}
  //         className={cardClass}
  //         onClick={() => handleCardClick(name)}
  //         style={{ cursor: connected ? "default" : "pointer" }}
  //       >
  //         {!clicked ? (
  //           <img
  //             src={icon}
  //             alt={`${name} Logo`}
  //             className={`connector-img-${className}`}
  //           />
  //         ) : (
  //           <div className="disconnected-message">
  //             <span>
  //               <b>{t("sourceConnectorNew.contactUs")}</b>{" "}
  //               {t("sourceConnectorNew.contactUsSuffix")}
  //             </span>
  //           </div>
  //         )}
  //       </div>
  //     </Tippy>
  //   );
  // })}

  return (
    <div className="connected-sources-container" dir={direction}>
      <div className="connected-sources-content">
        <div className="source-connector-header">
          <Title level={2} className="connect-header">
            {t("sourceConnectorNew.title")}
          </Title>
        </div>
        <Paragraph className="sub-heading">
          {t("sourceConnectorNew.subtitle")}
        </Paragraph>

        <div className="cards-grid">
          {CONNECTED_SOURCES.map(({ name, icon, className, connected }) => {
            const cardClass = `connected-card ${className} ${
              connected ? "highlight-border" : ""
            }`;

            return (
              <Tippy key={name} content={t("sourceConnectorNew.connected")}>
                <div className={cardClass}>
                  <img
                    src={icon}
                    alt={`${name} Logo`}
                    className={`connector-img-${className}`}
                  />
                </div>
              </Tippy>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ConnectedSources;
